<template>
  <div>
    <div class="w-full relative">
      <div class="text-sm">
        <strong>Kwalificaties</strong> (meerdere opties mogelijk):
      </div>
      <div
        :class="selectOpen ? 'border-b-0' : 'border-b-2'"
        class="w-full flex justify-between items-center pl-0 py-1 border-primary-medium cursor-pointer"
        @click="toggleSelect">
        <div class="flex flex-wrap">
          <div v-for="tag in selected" :key="itemKey ? tag[itemKey] : tag" class="tag">
            {{ itemKey ? tag[itemKey] : tag }}
          </div>
        </div>
        <button>
          <font-awesome-icon :icon="selectOpen ? ['fas', 'caret-up'] : ['fas', 'caret-down']" size="sm"/>
        </button>
      </div>

      <transition name="slide">
        <div v-if="selectOpen" class="h-64 overflow-scroll shadow-inner">
          <ul class="bg-primary-lighter rounded -mt-1">
            <li v-for="(tag, index) in tags" :key="index" class="text-sm" @click="selectTag(tag)">
              <span
                :class="selected.includes(tag) ? 'font-bold' : ''"
                class="rounded-t hover:bg-primary-light py-2 px-4 block whitespace-no-wrap transition duration-300 ease"
              >{{ itemKey ? tag[itemKey] : tag }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <nuxt-link to="/kwalificaties" class="block mt-2 text-xs link-secondary">
      Welke kwalificaties zijn er?
    </nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    selectOpen: false,
    selected: [],
  }),
  watch: {
    selected() {
      this.$emit('input', this.selected);
    },
  },
  methods: {
    toggleSelect() {
      this.selectOpen = !this.selectOpen;
    },
    selectTag(tag) {
      if (this.selected.includes(tag)) {
        this.selected = this.selected.filter(select => select !== tag);
      } else {
        this.selected.push(tag);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  @apply flex items-center justify-center bg-primary-light px-3 py-1 mr-2 text-sm;
  border-radius: 11.5px;
}

.slide-enter-active, .slide-leave-active {
  transition: all .3s ease;
}

.slide-enter, .slide-leave-to {
  height: 0;
}
</style>
